import { Link } from "react-router-dom";
import { Check, ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/Kinetic";
import { SERVICES, SITE, EMAILS } from "@/data/site";

export default function Services() {
  return (
    <main data-testid="page-services" className="pt-20">
      <section className="mx-auto max-w-7xl px-5 py-20 sm:px-8 lg:px-12 lg:py-28">
        <Reveal>
          <Eyebrow>Services</Eyebrow>
          <h1 className="mt-6 max-w-3xl font-display text-5xl font-semibold leading-[1.05] text-ivory sm:text-6xl">
            Choreography for the <em className="gold-text italic">whole day.</em>
          </h1>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-ivory/70">
            From the first handshake at arrivals to the last drop-off of the
            night — one call handles it all.
          </p>
        </Reveal>
      </section>

      <section className="mx-auto max-w-7xl space-y-24 px-5 pb-28 sm:px-8 lg:px-12">
        {SERVICES.map((s, i) => (
          <Reveal key={s.id}>
            <article
              className={`grid items-center gap-10 lg:grid-cols-2 lg:gap-16 ${
                i % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""
              }`}
              data-testid={`services-block-${s.no}`}
            >
              <div className="group relative overflow-hidden rounded-2xl border border-gold/15">
                <img
                  src={s.img}
                  alt={s.title}
                  className="aspect-[16/11] w-full object-cover transition-transform duration-[1.6s] ease-out group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-obsidian-900/60 to-transparent" />
                <span className="absolute left-6 top-6 font-mono text-xs tracking-[0.3em] text-gold">
                  {s.no}
                </span>
              </div>
              <div>
                <h2 className="font-display text-4xl font-semibold text-ivory sm:text-5xl">
                  {s.title}
                </h2>
                <p className="mt-5 max-w-lg text-base leading-relaxed text-ivory/70">
                  {s.desc}
                </p>
                <ul className="mt-7 space-y-3">
                  {s.points.map((p) => (
                    <li key={p} className="flex items-center gap-3 text-sm text-ivory/80">
                      <span className="flex h-5 w-5 items-center justify-center rounded-full border border-gold/40">
                        <Check className="h-3 w-3 text-gold" />
                      </span>
                      {p}
                    </li>
                  ))}
                </ul>
                <Link
                  to="/reservation"
                  data-testid={`services-reserve-${s.id}`}
                  className="group mt-8 inline-flex items-center gap-2 rounded-full border border-gold/40 px-7 py-3.5 font-mono text-[11px] uppercase tracking-[0.2em] text-gold transition-all duration-300 hover:bg-gold hover:text-obsidian-900"
                >
                  Reserve
                  <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </Link>
              </div>
            </article>
          </Reveal>
        ))}
      </section>

      <section className="border-t border-gold/10 bg-obsidian-800/40">
        <div className="mx-auto max-w-7xl px-5 py-16 text-center sm:px-8">
          <Reveal>
            <p className="font-mono text-[11px] uppercase tracking-[0.24em] text-gold">
              Something else in mind?
            </p>
            <p className="mx-auto mt-4 max-w-xl font-display text-2xl text-ivory sm:text-3xl">
              {SITE.phone ? "Call dispatch at " : "Email reservations at "}
              <a
                href={SITE.phone ? SITE.phoneHref : `mailto:${EMAILS.reservations}`}
                data-testid="services-contact-link"
                className="gold-text italic"
              >
                {SITE.phone || EMAILS.reservations}
              </a>{" "}
              — if it rides on wheels, we will arrange it.
            </p>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
